import { AppState } from 'common/appState';

export const getFetchingDownloadStatus = (state: AppState) => state.download.isFetching;

export const getDownloadedInvoiceUrl = (state: AppState) => state.download.downloadedInvoiceUrl;
